import { useAtomValue } from 'jotai';
import { competitionIdsToFilterByAtom } from '@/atoms/filters/highLevel/competitions';
import { seasonIdsToFilterByAtom } from '@/atoms/filters/highLevel/seasons';
import { cyclesForSectionAtom } from '@/atoms/section/cycles';

/**
 * This hook gets the selected cycles where the has360 field matches the provided has360Check
 * based on the currently selected competition and season filters.
 *
 * You might wonder why we don't make this a derived atom instead. The reason is that
 * I'm trying to minimise the amount of times we have to re-run this logic, and
 * using a hook that we call only when we need to set the banner message means we
 * only run this logic when necessary.
 */
export const useSelectedCyclesMatching360Check = (has360Check: boolean) => {
  const cycles = useAtomValue(cyclesForSectionAtom);
  const competitionIdsToFilterBy = useAtomValue(competitionIdsToFilterByAtom);
  const seasonIdsToFilterBy = useAtomValue(seasonIdsToFilterByAtom);

  return () => {
    const competitionLookup = new Set(competitionIdsToFilterBy);
    const seasonLookup = new Set(seasonIdsToFilterBy);

    return cycles.filter(
      ({ competitionId, seasonId, has360 }) =>
        has360 === has360Check &&
        competitionLookup.has(competitionId) &&
        (seasonIdsToFilterBy.length === 0 || seasonLookup.has(seasonId)),
    );
  };
};
